/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Saved_SuccessfullyInputs */

const en_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share link saved successfully`)
};

const fr_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien de partage enregistré avec succès`)
};

const de_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link zum Teilen erfolgreich gespeichert`)
};

const it_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il collegamento salvato correttamente`)
};

const ru_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка для обмена успешно сохранена.`)
};

const es_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace compartido guardado exitosamente`)
};

const zh_cn2_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享链接已成功保存`)
};

const ja_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有リンクが正常に保存されました`)
};

const hi_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर लिंक सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_team_share_saved_successfully = /** @type {(inputs: Team_Share_Saved_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O link de compartilhamento foi salvo com sucesso.`)
};

/**
* | output |
* | --- |
* | "Share link saved successfully" |
*
* @param {Team_Share_Saved_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_saved_successfully = /** @type {((inputs?: Team_Share_Saved_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Saved_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_saved_successfully(inputs)
	if (locale === "de") return de_team_share_saved_successfully(inputs)
	if (locale === "it") return it_team_share_saved_successfully(inputs)
	if (locale === "ru") return ru_team_share_saved_successfully(inputs)
	if (locale === "es") return es_team_share_saved_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_saved_successfully(inputs)
	if (locale === "ja") return ja_team_share_saved_successfully(inputs)
	if (locale === "hi") return hi_team_share_saved_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_saved_successfully(inputs)
	return en_team_share_saved_successfully(inputs)
});